import type { LockScreenTexts } from "@ews-admin/global-design-system";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/** MED-1622: every text of the design system LockScreen, translated. */
export const useLockScreenTexts = (
  extra: Partial<LockScreenTexts> = {}
): LockScreenTexts => {
  const { t } = useTranslation();
  const { otpDescription, cancel } = extra;

  return useMemo(
    () => ({
      dialogLabel: t("pinLock.dialogLabel"),
      createTitle: t("pinLock.createTitle"),
      confirmTitle: t("pinLock.confirmTitle"),
      unlockTitle: t("pinLock.unlockTitle"),
      currentTitle: t("pinLock.currentTitle"),
      newTitle: t("pinLock.newTitle"),
      otpTitle: t("pinLock.otpTitle"),
      otpDescription,
      otpLabel: t("pinLock.otpLabel"),
      otpSubmit: t("pinLock.otpSubmit"),
      mismatchError: t("pinLock.errors.mismatch"),
      forgot: t("pinLock.forgot"),
      cancel,
      signOut: t("pinLock.logout"),
      erase: t("pinLock.erase"),
      keypad: t("pinLock.keypad"),
      progress: (filled: number, total: number) =>
        t("pinLock.progress", { filled, total }),
      digit: (position: number, total: number) =>
        t("pinLock.digit", { position, total }),
    }),
    [t, otpDescription, cancel]
  );
};
